import React, { useContext } from "react";
import { CalendarClock } from "lucide-react";
import { AuthContext } from "../../context/AuthContext";
import TimetablePage from "./TimetablePage";
import RoleScopedPlaceholder from "../../components/RoleScopedPlaceholder";

/**
 * Routes timetable access based on role:
 *   • IT Admin / Support User → full CRUD timetable page
 *   • College Admin           → read-only timetable for their college
 *   • Anyone else (faculty etc.) → role-aware placeholder (their menu also hides it)
 */
export default function PortalTimetableRoute() {
  const { user } = useContext(AuthContext);
  const role = user?.role;
  if (role === "it_admin" || role === "support_user") return <TimetablePage />;
  if (role === "college_admin") return <TimetablePage readOnly />;
  return <RoleScopedPlaceholder title="Timetable" moduleKey="timetable" icon={CalendarClock} />;
}
